/**
 * Shared date/time formatting helpers.
 * Patient-facing UI uses DD.MM.YYYY HH:MM regardless of locale (Austrian convention).
 */

function pad(n) {
  return String(n).padStart(2, '0');
}

/**
 * Returns "DD.MM.YYYY HH:MM" — guards against invalid Date input.
 */
export function formatDateTime(input) {
  if (!input) return '—';
  const d = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(d.getTime())) return '—';
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/**
 * Returns "HH:MM" only.
 */
export function formatTime(input) {
  if (!input) return '—';
  const d = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(d.getTime())) return '—';
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/**
 * Returns "DD.MM.YYYY".
 */
export function formatDate(input) {
  if (!input) return '—';
  const d = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(d.getTime())) return '—';
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`;
}
